import monetize from '@sdk/helpers/formatters/monetize';
import identify from '@sdk/helpers/misc/expenses';

import BANKS from '@sdk/helpers/domains/banks';

const INTEGRATED = [
  { code: BANKS.BRADESCO.code },
  { code: BANKS.BV.code },
  { code: BANKS.C6.code },
  { code: BANKS.CREDITAS.code },
  { code: BANKS.FONTECRED.code },
  { code: BANKS.HONDA.code },
  { code: BANKS.HYUNDAI.code },
  { code: BANKS.ITAU.code },
  { code: BANKS.KUNA.code },
  { code: BANKS.MONEYPLUS.code },
  { code: BANKS.PAN.code },
  { code: BANKS.SAFRA.code },
  { code: BANKS.SANTANDER.code },
  { code: BANKS.VOLKSWAGEN.code },
];

export function table(t) {
  return (t && t.description) || 'Em branco';
}

const DEFAULT_PLAN_LABEL = 'Retorno';

export function plan(p) {
  const id = p && p.external_plan_id ? p.external_plan_id : null;

  let label = DEFAULT_PLAN_LABEL;

  if (p && p.return) {
    label += ` ${p.return - (typeof p.return_offset === 'number' ? p.return_offset : 0)}`;
  }

  if (id) {
    label += ` - ${id}`;
  }

  return label === DEFAULT_PLAN_LABEL ? 'Em branco' : label;
}

export function insurances(attempt) {
  return attempt.expenses.map(expense => ({
    label: identify(expense),
    value: monetize(expense.value_in_cents),
  }));
}

export function interests(attempt) {
  const {
    cet_annually: cetA,
    cet_monthly: cetM,
    interest_annually: interestA,
    interest_monthly: interestM,
  } = attempt;

  const list = [];
  const candidates = [
    [cetA, 'CET - Anual'],
    [cetM, 'CET - Mensal'],
    [interestA, 'Taxa de juros - Anual'],
    [interestM, 'Taxa de juros - Mensal'],
  ];

  candidates
    .filter(candidate => candidate[0])
    .forEach(candidate => list.push({
      label: candidate[1],
      value: `${String(candidate[0]).replace('.', ',')}%`,
    }));

  return list;
}

export function balloons(list, balloon) {
  const existing = list[balloon.value_cents] || { installments: 0, months: [] };
  existing.months.push(balloon.installment_number);
  existing.installments += 1;

  return {
    ...list,
    [balloon.value_cents]: existing,
  };
}

export function integrated(attempt, customer = {}) {
  if (customer.cnpj) {
    return false;
  }

  const {
    external_proposal_uuid: proposalUUID,
    external_simulation_uuid: simulationUUID,
    bank,
  } = attempt;

  return INTEGRATED
    .find(i => i.code === (bank && bank.febraban_code)) && !!(proposalUUID || simulationUUID);
}

export function installments(attempt) {
  if (!attempt || !attempt.payment_flow) {
    return [{
      label: 'Parcelas',
      value: 'Não disponivel',
    }];
  }

  const {
    payment_flow: flow,
  } = attempt;

  if (!flow || !flow.length) {
    return [{
      label: 'Parcelas',
      value: `${attempt.term_financing}x ${monetize(attempt.quota_in_cents)}`,
    }];
  }

  const reduced = flow.reduce(balloons, {});
  const list = [];

  Object.keys(reduced)
    .sort((a, b) => reduced[b].installments - reduced[a].installments)
    .forEach((installment, index) => {
      const balloon = reduced[installment];

      list.push({
        // eslint-disable-next-line no-nested-ternary
        label: index ? (balloon.installments > 1 ? 'Balões' : 'Balão') : 'Parcelas',
        value: `${index ? '+' : ''} ${balloon.installments}x ${monetize(installment)}`,
      });

      if (index) {
        list.push({
          label: 'Nos meses',
          value: balloon.months.sort((a, b) => a - b).join(', '),
        });
      }
    });

  return list;
}
